import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { AlertAnalyzesGroupsDemoService } from 'src/app/design/demo-services/alert-analyzes-group-demo.service';


@Injectable({
  providedIn: 'root'
})
export class AlertAnalyzesGroupService {

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private demoService: AlertAnalyzesGroupsDemoService) { }

  getGroupsAlertDate(): Observable<any> {
    
    var url = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/callboard/getRollupGroups`;

    const loader = this.route.params.pipe(
      switchMap(bl => 
        (environment.demo ? this.demoService.get() : this.http.get(url))
          .pipe(
            map((b: any) => b),
            catchError(error => of({
              isLoading: false, 
              isLoaded: false,
              isError: true,
              errorMessage: error.error instanceof ErrorEvent ? `an error occurred: ${error.error.message}` : `backend error: ${error.status} - ${error.message}`,
              data: {}
            }))
          )
      ),
      map((d: any) => {

        const ret = d.isError === true ? d : {

          groups: [] = d,
          isNotFound: d.length === 0,

          isLoading: false,
          isLoaded: true,
          isError: false,
          errorMessage: ''
        };
        return ret;
      })
    );
    return loader;
  }
}
